import { tw } from '@/utils/tw';

const ArticleDisclosureLabel = tw.theme({
  base: [
    'sticky',
    'max-w-content',
    'bg-black',
    'px-2',
    'py-1',
    'mb-3',
    'mx-auto',
    'text-center',
    'text-white',
    'transition-transform',
    'duration-500',
    'ease-in-out',
    'wings',
    'wings-black',
    'md:wings-none',
    'text-body-xs',
    '!z-article-disclosure',
  ],
});

export default ArticleDisclosureLabel;
